import { Outlet } from "react-router-dom";
import '../App.css';
import { useContext } from "react";
import { TextContext } from "../context/TextContext";
import { ToastContainer } from "react-toastify";

const MainLayout = () => {
    const { sharedText, setSharedText } = useContext(TextContext);

    return (
        <div class="col-md-6 card min-vh-100 m-auto border-0">
            <Outlet />
            <ToastContainer />
        </div>
    );
};


export default MainLayout;
